module.exports = __webpack_public_path__ + "static/media/IMG_8550.cb02559e.JPG";